import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'numberTruncated',
	standalone: false,
})
export class NumberTruncatedPipe implements PipeTransform {
	transform(
		value: number | null | undefined,
		{
			prefix = '',
			suffix = '',
			millionsDecimalPlaces = 2,
			thousandsDecimalPlaces = 1,
			tensDecimalPlaces = 2,
		}: { prefix?: string; suffix?: string; millionsDecimalPlaces?: number; thousandsDecimalPlaces?: number; tensDecimalPlaces?: number } = {},
	): string {
		if (value === null || value === undefined || isNaN(value)) {
			return '--';
		}

		const absValue = Math.abs(value);
		const sign = value < 0 ? '-' : '';
		let result = '';

		if (absValue >= 1000000) {
			const factor = Math.pow(10, millionsDecimalPlaces);
			result = (Math.trunc((absValue / 1000000) * factor) / factor).toFixed(millionsDecimalPlaces) + 'M';
		} else if (absValue >= 1000) {
			const factor = Math.pow(10, thousandsDecimalPlaces);
			result = (Math.trunc((absValue / 1000) * factor) / factor).toFixed(thousandsDecimalPlaces) + 'K';
		} else {
			const factor = Math.pow(10, tensDecimalPlaces);
			result = (Math.trunc(absValue * factor) / factor).toFixed(tensDecimalPlaces);
		}

		return prefix + sign + result + suffix;
	}
}
